/* =========================================================================
   7elm motion layer (GSAP + ScrollTrigger + SplitText).
   - Intro loader, custom cursor, curtain page transitions
   - Text / item / image reveals, hero text, marquee speed, tiles, tabs, FAQ
   - Full-screen menu with the animated "7elm = Dream"
   - Moving lines, Our story page, Refunds & exchanges steps
   Respects prefers-reduced-motion and stays calm inside the theme editor.
   ========================================================================= */
(function () {
  'use strict';
  var html = document.documentElement;
  var body = document.body;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var G = window.gsap, ST = window.ScrollTrigger, Split = window.SplitText;
  var store = (function () { try { return window.sessionStorage; } catch (e) { return null; } })();
  var setS = function (k, v) { try { if (store) store.setItem(k, v); } catch (e) {} };
  var delS = function (k) { try { if (store) store.removeItem(k); } catch (e) {} };
  var pad = function (n) { return String(n).padStart(2, '0'); };

  window.__7elmReady = true;
  var on = html.classList.contains('motion-ok') && !!G && !!ST && !reduce;
  if (G && ST) G.registerPlugin(ST);
  if (G && Split) G.registerPlugin(Split);

  /* ---------- intro gate ---------- */
  var introDone = false, introQueue = [];
  function onIntro(cb) { if (introDone) cb(); else introQueue.push(cb); }
  function finishIntro() {
    if (introDone) return;
    introDone = true;
    html.classList.add('intro-seen');
    setS('7elm-intro', '1');
    introQueue.splice(0).forEach(function (cb) { cb(); });
  }

  if (!on) {
    // No motion: show everything, keep the essentials working.
    html.classList.remove('motion-ok', 'curtain-on');
    html.classList.add('intro-seen');
    delS('7elm-curtain');
    finishIntro();
    $$('[data-story]').forEach(storyBasic);
    return;
  }

  /* =======================================================================
     INTRO LOADER
     ======================================================================= */
  function runIntro() {
    var el = $('[data-intro]');
    if (!el || html.classList.contains('intro-seen')) { finishIntro(); return; }
    var clock = $('[data-clock]', el), count = $('[data-count]', el), bar = $('[data-bar]', el);
    var logo = $('.intro__logo', el), rows = $$('.intro__row', el);
    var fmt;
    try { fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Cairo', hour: '2-digit', minute: '2-digit', second: '2-digit' }); } catch (e) { fmt = null; }
    var tick = function () { if (clock && fmt) clock.textContent = fmt.format(new Date()); };
    tick();
    var iv = setInterval(tick, 1000);
    var n = { v: 0 };
    G.timeline({ onComplete: function () { clearInterval(iv); el.remove(); } })
      .from(rows, { autoAlpha: 0, y: 12, stagger: 0.1, duration: 0.6, ease: 'power2.out' })
      .to(n, { v: 100, duration: 1.6, ease: 'power2.inOut', onUpdate: function () { if (count) count.textContent = pad(Math.round(n.v)); } }, 0.1)
      .to(bar, { scaleX: 1, duration: 1.6, ease: 'power2.inOut' }, 0.1)
      .fromTo(logo, { scale: 1.6, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, duration: 0.7, ease: 'expo.out' }, 1.2)
      .to(rows.concat(bar ? [bar.parentNode] : []), { autoAlpha: 0, duration: 0.3 }, 1.95)
      .to(logo, { scale: 0.9, autoAlpha: 0, duration: 0.4, ease: 'power2.in' }, 2.15)
      .to('.intro__half--t', { yPercent: -100, duration: 0.9, ease: 'expo.inOut' }, 2.3)
      .to('.intro__half--b', { yPercent: 100, duration: 0.9, ease: 'expo.inOut' }, 2.3)
      .add(finishIntro, 2.55);
  }

  /* =======================================================================
     CURTAIN (page to page)
     ======================================================================= */
  function curtainEl() {
    var c = $('[data-curtain]');
    if (c) return c;
    // The story's "next page" works even if page transitions are off.
    var logo = $('.story-end__logo');
    c = document.createElement('div');
    c.className = 'curtain';
    c.setAttribute('aria-hidden', 'true');
    if (logo) { var im = document.createElement('img'); im.src = logo.currentSrc || logo.src; im.alt = ''; c.appendChild(im); }
    body.appendChild(c);
    return c;
  }
  function curtainGo(url) {
    if (!url) return;
    var c = curtainEl(), img = $('img', c);
    setS('7elm-curtain', '1');
    var fallback = setTimeout(function () { window.location.href = url; }, 2500);
    G.timeline({ onComplete: function () { clearTimeout(fallback); window.location.href = url; } })
      .set(c, { pointerEvents: 'all' })
      .fromTo(c, { yPercent: 100 }, { yPercent: 0, duration: 0.75, ease: 'expo.inOut' })
      .fromTo(img, { autoAlpha: 0, scale: 0.85 }, { autoAlpha: 1, scale: 1, duration: 0.45, ease: 'expo.out' }, '-=0.2');
  }
  function curtainLift() {
    delS('7elm-curtain');
    var c = $('[data-curtain]');
    if (!c || !html.classList.contains('curtain-on')) { html.classList.remove('curtain-on'); return; }
    var img = $('img', c);
    G.set(c, { yPercent: 0, pointerEvents: 'none' });
    G.set(img, { autoAlpha: 1 });
    html.classList.remove('curtain-on');
    G.timeline({ onComplete: function () { G.set([c, img], { clearProps: 'all' }); } })
      .to(img, { autoAlpha: 0, y: -24, duration: 0.35, ease: 'power2.in', delay: 0.1 })
      .to(c, { yPercent: -100, duration: 0.9, ease: 'expo.inOut' }, '-=0.1');
  }
  function initTransitions() {
    if (body.dataset.transitions !== 'true' || design) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download') || a.hasAttribute('data-open') || a.closest('[data-no-curtain]')) return;
      var u;
      try { u = new URL(a.getAttribute('href'), window.location.href); } catch (x) { return; }
      if (u.origin !== window.location.origin) return;
      if (u.pathname === window.location.pathname && u.search === window.location.search) return;
      if (/^\/(checkout|account\/logout|cart\/(add|change|clear|update))/.test(u.pathname)) return;
      e.preventDefault();
      curtainGo(u.href);
    });
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      html.classList.remove('curtain-on');
      var c = $('[data-curtain]');
      if (c) G.set(c, { clearProps: 'all' });
    });
  }

  /* =======================================================================
     CURSOR + MAGNETIC
     ======================================================================= */
  function initCursor() {
    if (body.dataset.cursorOn !== 'true' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var c = document.createElement('div');
    c.className = 'm-cursor is-hidden';
    c.innerHTML = '<span class="m-cursor__dot"></span><span class="m-cursor__ring"><span class="m-cursor__label"></span></span>';
    body.appendChild(c);
    body.classList.add('has-cursor');
    var dot = $('.m-cursor__dot', c), ring = $('.m-cursor__ring', c), label = $('.m-cursor__label', c);
    var dx = G.quickTo(dot, 'x', { duration: 0.12 }), dy = G.quickTo(dot, 'y', { duration: 0.12 });
    var rx = G.quickTo(ring, 'x', { duration: 0.45, ease: 'power3' }), ry = G.quickTo(ring, 'y', { duration: 0.45, ease: 'power3' });
    var labelFor = function (el) {
      var l = el.closest('[data-cursor]');
      if (l) return l.getAttribute('data-cursor');
      if (el.closest('.card__media')) return 'View';
      if (el.closest('.tile')) return 'Shop';
      return '';
    };
    window.addEventListener('mousemove', function (e) {
      dx(e.clientX); dy(e.clientY); rx(e.clientX); ry(e.clientY);
      c.classList.remove('is-hidden');
      var t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      var text = labelFor(t);
      var hot = !!t.closest('a, button, summary, label, [data-cursor]');
      c.classList.toggle('is-label', !!text && !t.closest('button, .qcircle'));
      c.classList.toggle('is-hover', hot && !text);
      if (text) label.textContent = text;
    }, { passive: true });
    document.addEventListener('mouseleave', function () { c.classList.add('is-hidden'); });

    // Buttons lean toward the cursor.
    document.addEventListener('mousemove', function (e) {
      var b = e.target instanceof Element ? e.target.closest('.btn, .testi__arrow, .story-rail button') : null;
      if (!b) return;
      var r = b.getBoundingClientRect();
      G.to(b, { x: (e.clientX - (r.left + r.width / 2)) * 0.25, y: (e.clientY - (r.top + r.height / 2)) * 0.35, duration: 0.4, ease: 'power3.out' });
      if (!b._mag) { b._mag = true; b.addEventListener('mouseleave', function () { G.to(b, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, 0.4)' }); }); }
    }, { passive: true });
  }

  /* =======================================================================
     REVEALS
     ======================================================================= */
  function splitReveal(scope) {
    $$('[data-split], .block__title, .statement__text', scope).forEach(function (el) {
      if (el._m || el.closest('.drawer')) return;
      el._m = true;
      el.classList.add('m-split-ready');
      if (!Split) return;
      Split.create(el, {
        type: 'lines', mask: 'lines', linesClass: 'm-line', autoSplit: true,
        onSplit: function (self) {
          return G.from(self.lines, { yPercent: 110, duration: 1.1, ease: 'expo.out', stagger: 0.08, scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
        }
      });
    });
  }
  var ITEMS = '[data-reveal], .grid>*, .rail__i, .testi__i, .insta__i, .acc, .usp__i, .ex, .returns-rule, .returns-step';
  function itemReveal(scope) {
    var els = $$(ITEMS, scope).filter(function (el) { return !el._rv && !el.closest('.drawer'); });
    if (!els.length) return;
    els.forEach(function (el) { el._rv = true; });
    G.set(els, { y: 30 });
    ST.batch(els, {
      start: 'top 94%', once: true,
      onEnter: function (batch) { G.to(batch, { autoAlpha: 1, y: 0, duration: 0.9, ease: 'expo.out', stagger: 0.08, overwrite: true }); }
    });
  }
  function tilesReveal(scope) {
    $$('.tiles', scope).forEach(function (t) {
      if (t._m) return; t._m = true;
      G.timeline({ scrollTrigger: { trigger: t, start: 'top 88%', once: true } })
        .fromTo($$('.tile', t), { clipPath: 'inset(100% 0% 0% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.2, ease: 'expo.inOut', stagger: 0.12 })
        .fromTo($$('.tile__label', t), { y: 24, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.8, ease: 'expo.out', stagger: 0.08 }, '-=0.5');
    });
  }
  function heroText(scope) {
    $$('[data-hero]', scope).forEach(function (h) {
      if (h._m) return; h._m = true;
      var parts = $$('.slide__txt > *', h), proof = $('.hero__proof', h);
      onIntro(function () {
        G.fromTo(parts, { autoAlpha: 0, y: 34 }, { autoAlpha: 1, y: 0, duration: 1.1, ease: 'expo.out', stagger: 0.08, delay: 0.1 });
        if (proof) G.fromTo(proof, { autoAlpha: 0 }, { autoAlpha: 1, duration: 1, delay: 0.6 });
      });
      // Copy drifts up and fades as you scroll past the hero.
      G.to($$('.slide__txt', h), { yPercent: -30, autoAlpha: 0.2, ease: 'none', scrollTrigger: { trigger: h, start: 'top top', end: 'bottom top', scrub: true } });
    });
  }
  function linesInit(scope) {
    $$('[data-lines]', scope).forEach(function (sec) {
      if (sec._m) return; sec._m = true;
      $$('[data-line]', sec).forEach(function (line, i) {
        G.fromTo(line, { xPercent: i % 2 ? -30 : 0 }, { xPercent: i % 2 ? 0 : -30, ease: 'none', scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: true } });
      });
    });
  }
  function stepsLine(scope) {
    $$('[data-steps]', scope).forEach(function (s) {
      if (s._m) return; s._m = true;
      G.fromTo($('[data-steps-line]', s), { scaleY: 0 }, { scaleY: 1, ease: 'none', scrollTrigger: { trigger: s, start: 'top 70%', end: 'bottom 60%', scrub: true } });
    });
  }

  /* marquee speeds up while you scroll, then settles */
  function initMarquee() {
    var anims = [];
    $$('.mq__track').forEach(function (t) { if (t.getAnimations) anims = anims.concat(t.getAnimations()); });
    if (!anims.length) return;
    var rate = 1, target = 1;
    ST.create({ start: 0, end: 'max', onUpdate: function (self) { target = Math.min(5, 1 + Math.abs(self.getVelocity()) / 500); } });
    G.ticker.add(function () {
      target += (1 - target) * 0.05;
      rate += (target - rate) * 0.12;
      anims.forEach(function (a) { a.playbackRate = rate; });
    });
  }

  /* tabs: new cards rise in */
  function initTabs() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]');
      if (!b) return;
      var p = $('[data-panel="' + b.dataset.tab + '"]', b.closest('[data-tabs]'));
      if (!p) return;
      var items = $$('.rail__i', p);
      items.forEach(function (x) { x._rv = true; });
      G.fromTo(items, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, stagger: 0.06, duration: 0.7, ease: 'expo.out', overwrite: true });
      ST.refresh();
    });
  }

  /* FAQ / accordions open and close smoothly */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var s = e.target.closest('details.acc > summary, details.fgroup > summary');
      if (!s) return;
      var d = s.parentElement, panel = s.nextElementSibling;
      if (!panel) return;
      e.preventDefault();
      G.killTweensOf(panel);
      if (d.open) {
        G.to(panel, { height: 0, autoAlpha: 0, overflow: 'hidden', duration: 0.4, ease: 'power2.inOut', onComplete: function () { d.open = false; G.set(panel, { clearProps: 'all' }); } });
      } else {
        d.open = true;
        G.fromTo(panel, { height: 0, autoAlpha: 0, overflow: 'hidden' }, { height: 'auto', autoAlpha: 1, duration: 0.55, ease: 'expo.out', onComplete: function () { G.set(panel, { clearProps: 'all' }); } });
      }
    });
  }

  /* =======================================================================
     MENU: links stagger in, "7elm = Dream" plays every time it opens
     ======================================================================= */
  function initMenu() {
    var menu = $('#drawer-menu');
    if (!menu || menu._m) return;
    menu._m = true;
    var was = false;
    new MutationObserver(function () {
      var open = menu.classList.contains('is-open');
      if (open && !was) play();
      was = open;
    }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    function play() {
      G.fromTo($$('[data-menu-item]', menu), { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, stagger: 0.06, duration: 0.9, ease: 'expo.out', delay: 0.25, overwrite: true });
      var m = $('[data-meaning]', menu);
      if (!m) return;
      var txt = $('[data-meaning-body]', m);
      if (txt && !txt._split && Split) txt._split = Split.create(txt, { type: 'words', wordsClass: 'm-word' });
      var words = txt && txt._split ? txt._split.words : [];
      G.timeline({ delay: 0.45 })
        .fromTo($$('[data-eq]', m), { yPercent: 110 }, { yPercent: 0, stagger: 0.18, duration: 0.9, ease: 'expo.out' })
        .fromTo(words, { opacity: 0.18 }, { opacity: 1, stagger: 0.07, duration: 0.4, ease: 'none' }, '-=0.35')
        .fromTo($('.mmeaning__glyph', m), { scale: 0.85, rotate: -4 }, { scale: 1.1, rotate: 0, duration: 3.2, ease: 'power2.out' }, 0);
    }
  }

  /* =======================================================================
     OUR STORY
     ======================================================================= */
  function storyBasic(story) {
    // Without motion: the video still plays when on screen.
    var v = $('[data-frame-media] video', story);
    if (!v || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }).observe(v);
  }

  function initStory(story) {
    if (story._m) return;
    story._m = true;
    var hero = $('.story-hero', story), stage = $('[data-stage]', story), heroImg = $('.story-hero__img', story);
    var title = $('[data-hero-title]', story), ins = hero ? $$('[data-in]', hero) : [], copy = $('[data-hero-copy]', story);

    /* 1. opening: title letters rise, then it stays put and shrinks as the next part slides over */
    if (hero) {
      if (title && Split) {
        // words + chars: letters animate, but a word never breaks across lines
        var sp = Split.create(title, { type: 'words,chars', mask: 'chars' });
        G.set(title, { visibility: 'visible' });
        G.set(sp.chars, { yPercent: 120 });
        G.set(ins, { visibility: 'visible', autoAlpha: 0, y: 20 });
        onIntro(function () {
          G.timeline({ defaults: { ease: 'expo.out' } })
            .fromTo(heroImg, { scale: 1.35 }, { scale: 1.08, duration: 2.4 }, 0)
            .to(sp.chars, { yPercent: 0, stagger: 0.05, duration: 1.3 }, 0.3)
            .to(ins, { autoAlpha: 1, y: 0, stagger: 0.1, duration: 1 }, 0.9);
        });
      } else {
        G.set([title].concat(ins).filter(Boolean), { visibility: 'visible' });
      }
      G.to(copy, { yPercent: -40, autoAlpha: 0, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: '70% top', scrub: true } });
      ST.create({ trigger: hero, start: 'top top', end: 'bottom top', pin: true, pinSpacing: false });
      G.to(stage, { scale: 0.86, borderRadius: 28, filter: 'brightness(0.3)', ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    }

    /* 2. the name: pinned, words light up one by one */
    var dream = $('[data-dream]', story), dh = $('[data-dream-h]', story), dt = $('[data-dream-text]', story);
    if (dream && dt) {
      var words = Split ? Split.create(dt, { type: 'words', wordsClass: 'm-word' }).words : [];
      var mm = G.matchMedia();
      mm.add({ d: '(min-width: 990px)', m: '(max-width: 989px)' }, function (ctx) {
        var desk = ctx.conditions.d;
        G.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: desk ? { trigger: dream, start: 'top top', end: '+=170%', pin: true, scrub: 0.6 } : { trigger: dream, start: 'top 70%', end: 'bottom 60%', scrub: 0.6 }
        })
          .from(dh, { yPercent: 60, autoAlpha: 0, duration: 0.6, ease: 'power3.out' })
          .to(words, { opacity: 1, stagger: 0.1, duration: 0.5 }, '>-0.1');
      });
    }

    /* 3. chapters: sideways on desktop, reveal one by one on phones */
    var chapters = $('[data-chapters]', story);
    if (chapters) {
      var track = $('[data-track]', chapters), panels = $$('[data-panel]', chapters);
      var mm2 = G.matchMedia();
      mm2.add('(min-width: 990px)', function () {
        var dist = function () { return track.scrollWidth - window.innerWidth; };
        var scroll = G.to(track, { x: function () { return -dist(); }, ease: 'none', scrollTrigger: { trigger: chapters, start: 'top top', end: function () { return '+=' + dist(); }, pin: true, scrub: 0.8, invalidateOnRefresh: true } });
        panels.forEach(function (p) {
          G.fromTo($('img', p), { xPercent: -12, scale: 1.15 }, { xPercent: 12, scale: 1, ease: 'none', scrollTrigger: { trigger: p, containerAnimation: scroll, start: 'left right', end: 'right left', scrub: true } });
          G.from($$('[data-chin]', p), { y: 60, autoAlpha: 0, stagger: 0.1, duration: 1, ease: 'expo.out', scrollTrigger: { trigger: p, containerAnimation: scroll, start: 'left 70%', once: true } });
        });
      });
      mm2.add('(max-width: 989px)', function () {
        panels.forEach(function (p) {
          G.fromTo($('.story-chapter__media', p), { clipPath: 'inset(100% 0% 0% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.3, ease: 'expo.inOut', scrollTrigger: { trigger: p, start: 'top 80%', once: true } });
          G.from($$('[data-chin]', p), { y: 40, autoAlpha: 0, stagger: 0.1, duration: 1, ease: 'expo.out', scrollTrigger: { trigger: p, start: 'top 70%', once: true } });
        });
      });
    }

    /* 4. moving lines */
    linesInit(story);

    /* 5. video frame opens to full screen; plays only while on screen */
    var frame = $('[data-frame]', story), fm = $('[data-frame-media]', story);
    if (frame && fm) {
      var media = $('video, img', fm), v = $('video', fm);
      G.fromTo(fm, { clipPath: 'inset(14% 18% 14% 18%)' }, { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none', scrollTrigger: { trigger: frame, start: 'top 85%', end: 'top 5%', scrub: true } });
      if (media) G.fromTo(media, { scale: 1.3, yPercent: -6 }, { scale: 1, yPercent: 6, ease: 'none', scrollTrigger: { trigger: frame, start: 'top bottom', end: 'bottom top', scrub: true } });
      if (v) ST.create({ trigger: frame, start: 'top bottom', end: 'bottom top', onToggle: function (s) { if (s.isActive) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); } });
    }

    /* 6. values: cards flip up; the page turns white, then black again */
    var vals = $('[data-values]', story);
    if (vals) {
      G.from($$('[data-value]', vals), { rotateX: -75, y: 80, autoAlpha: 0, transformOrigin: '50% 0%', stagger: 0.12, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: $('.story-values__list', vals), start: 'top 82%', once: true } });
      G.timeline({ scrollTrigger: { trigger: vals, start: 'top 75%', end: 'bottom 25%', scrub: true } })
        .to(story, { '--sbg': '#f2eee7', '--sfg': '#0b0b0c', duration: 1, ease: 'none' })
        .to(story, { duration: 2 })
        .to(story, { '--sbg': '#0b0b0c', '--sfg': '#f2eee7', duration: 1, ease: 'none' });
    }

    /* 7. your turn: keep scrolling, the ring fills, the curtain takes you on */
    var end = $('[data-end]', story), ring = $('[data-ring]', story), pct = $('[data-pct]', story), next = story.dataset.next;
    $$('[data-go-next]', story).forEach(function (a) {
      a.addEventListener('click', function (e) { if (design) return; e.preventDefault(); e.stopPropagation(); curtainGo(next); });
    });
    if (end && ring && story.dataset.scrollNext === 'true') {
      var R = 339.29, fired = false, touched = false;
      var mark = function () { touched = true; };
      window.addEventListener('wheel', mark, { passive: true, once: true });
      window.addEventListener('touchmove', mark, { passive: true, once: true });
      window.addEventListener('keydown', mark, { once: true });
      ST.create({
        trigger: end, start: 'top top', end: '+=110%', pin: true,
        onUpdate: function (s) {
          G.set(ring, { strokeDashoffset: R * (1 - s.progress) });
          if (pct) pct.textContent = pad(Math.round(s.progress * 100));
          // Only real scrolling counts (not a restored position after Back), never in the editor.
          if (s.progress > 0.985 && s.direction > 0 && touched && !fired && !design) { fired = true; curtainGo(next); }
        }
      });
    }

    /* photos lean with scroll speed */
    var skew = $$('[data-skew]', story);
    if (skew.length) {
      var setters = skew.map(function (el) { return G.quickTo(el, 'skewY', { duration: 0.5, ease: 'power3.out' }); });
      ST.create({ trigger: story, start: 'top top', end: 'bottom bottom', onUpdate: function (s) { var k = G.utils.clamp(-6, 6, s.getVelocity() / -400); setters.forEach(function (set) { set(k); }); } });
    }

    /* chapter rail (desktop) */
    var rail = $('[data-rail]', story);
    if (rail) {
      var list = $('[data-rail-list]', rail), secs = $$('[data-chapter]', story);
      var btns = secs.map(function (s, i) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.innerHTML = '<span>' + pad(i + 1) + '</span><span class="story-rail__name"></span>';
        b.querySelector('.story-rail__name').textContent = s.getAttribute('data-chapter') || '';
        li.appendChild(b); list.appendChild(li);
        return b;
      });
      var trig = secs.map(function (s, i) {
        return ST.create({ trigger: s, start: 'top center', end: 'bottom center', onToggle: function (self) { if (self.isActive) btns.forEach(function (b, j) { if (j === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); }); } });
      });
      btns.forEach(function (b, i) { b.addEventListener('click', function () { window.scrollTo({ top: trig[i].start + 2, behavior: 'smooth' }); }); });
      G.to($('[data-rail-progress]', rail), { scaleY: 1, ease: 'none', scrollTrigger: { trigger: story, start: 'top top', end: 'bottom bottom', scrub: true } });
      ST.create({ trigger: story, start: 'top top', end: 'bottom bottom', onToggle: function (s) { G.to(rail, { autoAlpha: s.isActive ? 1 : 0, duration: 0.3 }); } });
    }
  }

  /* =======================================================================
     BOOT
     ======================================================================= */
  function initScope(scope) {
    $$('[data-story]', scope).forEach(initStory);
    heroText(scope);
    splitReveal(scope);
    itemReveal(scope);
    tilesReveal(scope);
    linesInit(scope);
    stepsLine(scope);
  }

  runIntro();
  curtainLift();
  initTransitions();
  initCursor();
  initMenu();
  initTabs();
  initAccordions();
  initScope(document);
  initMarquee();
  window.addEventListener('load', function () { ST.refresh(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ST.refresh(); });

  // Theme editor: rebuild a section's animations when it's edited.
  document.addEventListener('shopify:section:unload', function (e) {
    ST.getAll().forEach(function (t) { if (t.trigger && e.target.contains(t.trigger)) t.kill(true); });
  });
  document.addEventListener('shopify:section:load', function (e) {
    initScope(e.target);
    initMenu();
    ST.refresh();
  });
})();
